/**
 * Vuex mutations for the "posts" (feed) module.
 *
 * Synchronous state writers for the draft-posts list and the draft currently
 * loaded into the compose box. Async work (API calls) lives in operations.js,
 * which commits these mutations with the results.
 */
export default {
  setDraftPosts(state, draftPosts) {
    state.draftPosts = draftPosts;
  },
  deleteDraftPost(state, id) {
    state.draftPosts = state.draftPosts.filter(item => item.id !== id);
  },
  /** Set `state.draftDataPost` (the draft currently loaded into the compose box) to `post`. */
  addDataDraft(state, post) {
    state.draftDataPost = post;
  },
  // clearUnreadPosts(state) {
  //   console.log('Clearing unread posts collection');
  //   state.unreadPosts = [];
  // },
};
